export interface ElectoralUnit {
  code: string;
  name: string;
  electoralVotes: number;
  electorateWeight: number;
}

// Allocation issue du recensement 2020, applicable aux élections de 2024 et 2028.
// Source de référence : National Archives, vérifiée le 18/09/2026.
export const ELECTORAL_UNITS: ElectoralUnit[] = [
  ['AL','Alabama',9],['AK','Alaska',3],['AZ','Arizona',11],['AR','Arkansas',6],['CA','Californie',54],
  ['CO','Colorado',10],['CT','Connecticut',7],['DE','Delaware',3],['DC','District de Columbia',3],['FL','Floride',30],
  ['GA','Géorgie',16],['HI','Hawaï',4],['ID','Idaho',4],['IL','Illinois',19],['IN','Indiana',11],
  ['IA','Iowa',6],['KS','Kansas',6],['KY','Kentucky',8],['LA','Louisiane',8],['ME','Maine',4],
  ['MD','Maryland',10],['MA','Massachusetts',11],['MI','Michigan',15],['MN','Minnesota',10],['MS','Mississippi',6],
  ['MO','Missouri',10],['MT','Montana',4],['NE','Nebraska',5],['NV','Nevada',6],['NH','New Hampshire',4],
  ['NJ','New Jersey',14],['NM','Nouveau-Mexique',5],['NY','New York',28],['NC','Caroline du Nord',16],['ND','Dakota du Nord',3],
  ['OH','Ohio',17],['OK','Oklahoma',7],['OR','Oregon',8],['PA','Pennsylvanie',19],['RI','Rhode Island',4],
  ['SC','Caroline du Sud',9],['SD','Dakota du Sud',3],['TN','Tennessee',11],['TX','Texas',40],['UT','Utah',6],
  ['VT','Vermont',3],['VA','Virginie',13],['WA','Washington',12],['WV','Virginie-Occidentale',4],['WI','Wisconsin',10],['WY','Wyoming',3]
].map(([code, name, electoralVotes]) => ({ code: String(code), name: String(name), electoralVotes: Number(electoralVotes), electorateWeight: 360000 + Number(electoralVotes) * 465000 }));

export const STATE_OPTIONS = ELECTORAL_UNITS.filter((item) => item.code !== 'DC').map((item) => ({ code: item.code, name: item.name }));

export const ELECTORAL_TOTAL = ELECTORAL_UNITS.reduce((sum, item) => sum + item.electoralVotes, 0);
